import { render, staticRenderFns } from "./MainList.vue?vue&type=template&id=73bac6d7"
import script from "./MainList.vue?vue&type=script&lang=ts"
export * from "./MainList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports